import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';

const ARRIVAL_DATE_TOKEN = '{arrival_date}';
const TIME_LEFT_TOKEN = '{time_left}';
const SAMPLE_DAYS_FROM_NOW = 5;
const SAMPLE_TIME_LEFT = '2hrs 21mins';

@Component({
  selector: 'delivery-date-component-preview',
  templateUrl: './delivery-date-component-preview.component.html',
  styleUrls: ['./delivery-date-component-preview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class DeliveryDateComponentPreviewComponent {
  @Input() options: ShopPlugin.ProductPagePromise.DeliveryDateOptions;
  @Input() zipCodeAvailable = true;
  @Input() linkedCutoffOptions?: ShopPlugin.ProductPagePromise.CutoffTimerOptions;

  get renderedHtml(): string {
    if (!this.zipCodeAvailable) {
      return this.options?.fallbackMessage ?? '';
    }
    const message = this.options?.displayMessage ?? '';
    return message.replace(ARRIVAL_DATE_TOKEN, this.sampleArrivalDate);
  }

  get linkedCutoffHtml(): string | null {
    if (!this.linkedCutoffOptions || !this.zipCodeAvailable) return null;
    const message = this.linkedCutoffOptions.displayMessage ?? '';
    if (!message) return null;
    return message.replace(TIME_LEFT_TOKEN, `<b>${SAMPLE_TIME_LEFT}</b>`);
  }

  private get sampleArrivalDate(): string {
    const date = new Date();
    date.setDate(date.getDate() + SAMPLE_DAYS_FROM_NOW);
    const formatOptions: Intl.DateTimeFormatOptions =
      this.options?.promiseFormat === ShopPlugin.ProductPagePromise.DeliveryDatePromiseFormat.DATE_AND_DAY
        ? { weekday: 'long', month: 'long', day: 'numeric' }
        : { month: 'long', day: 'numeric' };
    return new Intl.DateTimeFormat('en-US', formatOptions).format(date);
  }
}
